export default "__VITE_ASSET__DaD6zshz__"